export const environment = {
  name: 'production',
  language1: "eng",
  sentryDSN: 'https://7425fa4da192f460eb6a8581afadcf22@o4506856956493824.ingest.us.sentry.io/4507975058391040',
  traceUrls: ['mit.mpo.dk', 'my.musicnest.no']
};
